import script from "./OnDemandIdBadges.vue?vue&type=script&setup=true&lang=js"
export * from "./OnDemandIdBadges.vue?vue&type=script&setup=true&lang=js"

import "./OnDemandIdBadges.vue?vue&type=style&index=0&id=010d6068&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-010d6068"]])

export default __exports__